import { z } from 'zod';

export const civilities = ['Mr', 'Mme'] as const;
export const civilitySchema = z.enum(civilities);
export type Civility = z.infer<typeof civilitySchema>;

export const maritalStatuses = [
  'UNKNOWN',
  'CELIBATAIRE',
  'MARIE',
  'PACSE',
  'DIVORCE',
  'VEUF',
  'SEPARE',
  'CONCUBINE',
] as const;
export const maritalStatusSchema = z.enum(maritalStatuses);
export type MaritalStatus = z.infer<typeof maritalStatusSchema>;
export const matrimonialRegimes = [
  'UNKNOWN',
  'CONTRACT',
  'COMMUNAUTE_LEGALE',
  'COMMUNAUT_UNIVERSELLE',
  'PARTICIPATION_ACQUETS',
  'SEPARATION_DE_BIENS',
  'AUTRE',
] as const;
export const matrimonialRegimeSchema = z.enum(matrimonialRegimes);

export const legalCapacities = [
  'PLEINE_ET_ENTIERE',
  'MINEUR',
  'MINEUR_EMANCIPE',
  'TUTELLE',
  'CURATELLE',
  'SAUVEGARDE_DE_JUSTICE',
] as const;
export const legalCapacitySchema = z.enum(legalCapacities);

export const statusesUsPerson = [
  'US_PERSON',
  'NON_US_PERSON',
  'RECALCITRANT',
] as const;
export const statusUsPersonSchema = z.enum(statusesUsPerson);
/* .default('NON_US_PERSON') */

export const professionalSituations = [
  'ACTIVE',
  'CHOMAGE',
  'ETUDIANTE',
  'RETRAITEE',
  'CUMUL_EMPLOI_RETRAITE',
] as const;

export const activeProfessionalSituations = [
  'ACTIVE',
  'CUMUL_EMPLOI_RETRAITE',
] satisfies ProfessionalSituation[];

export const retiredProfessionalSituations = [
  'RETRAITEE',
  'CUMUL_EMPLOI_RETRAITE',
] satisfies ProfessionalSituation[];

export const professionalSituationSchema = z.enum(professionalSituations);
export type ProfessionalSituation = z.infer<typeof professionalSituationSchema>;

export const socialRegimes = ['GENERAL', 'AGRICOLE', 'TNS'] as const;
export const socialRegimeSchema = z.enum(socialRegimes);

export const sectors = [
  'INDUSTRIE',
  'CONSTRUCTION',
  'COMMERCE',
  'TRANSPORTS_ET_ENTREPOSAGE',
  'HEBERGEMENT_ET_RESTAURATION',
  'INFORMATION_ET_COMMUNICATION',
  'IMMOBILIER',
  'SERVICES_AUX_ENTREPRISES',
  'ENSEIGNEMENT_SANTE_HUMAINE_ET_ACTION_SOCIALE',
  'SERVICES_AUX_PARTICULIERS',
] as const;

export const sectorSchema = z.enum(sectors);
